import React, { useEffect, useState } from "react";
import { Stepper } from "@mantine/core";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ecombo from "../../../../imgs/Logo_Ecombo 1.png";
import lightfunnels from "../../../../imgs/lightfunnels.svg"; 
import lf from "../../../../imgs/lf.png";
import Loader from "../../../loader/Loader";
import AxiosController from "../../../authentication/AxiosController";
import { notifySuccess, notifyError } from "../../../toastify/toastify";
import { getAuthUrl, handleOAuthCallback, syncSingleProduct } from "./LightFunnelsAPIKeys";

const LightFunnels = () => {
  const { slug: country, lang } = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");

  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);

  const getUserData = () => {
    setLoading(true);
    AxiosController.get(`api/${lang}/auth/userdata`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        setUserId(res.data["id"]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }; 

  const connectLightFunnels = async () => {
    setLoading(true);
    try {
      const code = urlParams.get("code");
      if (code) {
        await handleOAuthCallback(code, token, lang, country);
        notifySuccess(_("panel.lightFunnelsConnected"));
        setActive(2);
      }
    } catch (error) {
      notifyError(_("panel.connectionFailed"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserData(); 
    const code = urlParams.get("code");
    if (code) {
      connectLightFunnels();
    } else {
      setActive(urlParams.get("step") ? urlParams.get("step") - 1 : 0);
    }
  }, []);

  return (
    <div className="w-100 pt-3 position-relative">
      <Loader active={loading} />
      <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap">
        <img src={lightfunnels} width={"180px"} alt="Light Funnels" />
        <img src={ecombo} width={"180px"} alt="Ecombo" />
      </div>
      <div>
        <Stepper active={active} onStepClick={setActive} color="#59C6C9">
          <Stepper.Step
            label={_("panel.First step")}
            description={_("panel.linkAccount")}
            disabled
          >
            <div className="d-flex flex-column align-items-center gap-3">
              <div>
                <p className="fs-5">
                  {country === "ae" ? _("panel.inAE") : _("panel.inSA")}{" "}
                  {_("panel.First step")} {_("panel.lightFunnelsLink")}{" "}
                  <a
                    href={getAuthUrl(lang, country)}
                    style={{ color: "rgb(243, 168, 55)" }}
                  >
                    {_("panel.Click here")}
                  </a>
                </p>
              </div>
              <div>
                <img src={lf} width={"500px"} className="rounded"  alt="Link illustration" />
              </div>
            </div>
          </Stepper.Step>

          <Stepper.Step
            label={_("panel.Second step")}
            description={_("panel.syncProducts")}
            disabled
          >
            <div className="d-flex align-items-center flex-column w-100">
              <p className="flex-grow-1 w-75 fs-5 w-100">
                {_("panel.Second step")} {_("panel.lightFunnelsSync")}
              </p>
            </div>
            <div className="w-100 d-flex justify-content-center align-items-center mt-3">
              <button
                className="btn w-25"
                style={{ backgroundColor: "rgb(243, 168, 55)", color: "white" }}
                onClick={() => setActive(2)}
              >
                {_("panel.syncProducts")}
              </button>
            </div>
          </Stepper.Step>

          <Stepper.Completed>
            <p className="flex-grow-1 w-75 fs-5 w-100 text-center">{_("panel.linked")}</p>
            <div
              className="img d-flex justify-content-center flex-column w-100 align-items-center gap-5"
              style={{ color: "rgb(243, 168, 55)" }}
            >
              <img src={lightfunnels} width={"400px"} alt="Linked illustration" />
              <h3>{_("panel.lightFunnelsConnected")}</h3>
              <button
                className="btn w-25"
                style={{ backgroundColor: "rgb(243, 168, 55)", color: "white" }}
                onClick={() => setActive(0)}
              >
                {_("panel.newLink")}
              </button>
            </div>
          </Stepper.Completed>
        </Stepper>
      </div>
    </div>
  );
};

export default LightFunnels;